<template>
    <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
        <v-card>
                            <v-toolbar dark color="#f5f5f5" style="padding:0;text-align:left;height:40px;"
                                density="compact">
                                <v-toolbar-title style="font-size:16px;padding:0;font-weight:300px;margin:0;margin-left:10px;" >
                                    Protein Sequence
                                </v-toolbar-title>
                            </v-toolbar>
                            <div v-if="'UTA_Adapter_protein_sequence' in item">

                                    <v-table style="padding:15px;" density="comfortable" table-border>
                                        <tr><td style="width:40px;padding-right:20px;">Transcript</td><td>{{ item['UTA_Adapter_protein_sequence']['trancript'] }}</td></tr>
                                        <tr><td style="width:40px;">Protein</td><td>{{ item['UTA_Adapter_protein_sequence']['protein_id'] }}</td></tr>
                                    </v-table>
                                <v-card-subtitle style="padding-top:10px;">Sequence
                                </v-card-subtitle>
                                <div v-html="this.pseq" v-if="'protein_sequence' in item['UTA_Adapter_protein_sequence']">
                                </div>
                            </div>
                        </v-card>
    </span>
</template>
<script>
export default {
    data: function () {
        return {
            pseq: '',
        }
    },
    methods: {
        format_protein_sequence(pseq) {
            const prot_seq_length = 6

            let pseq_arr = pseq.match(/.{1,6}/g);
            let pseq_str = '<table style="margin:20px;width:100%;"><tr>'
            //alert(pseq_arr)
            let row_c = 0
            let protloc = 0
            for (let i = 0;i< pseq_arr.length; i += 1) {

                pseq_str += '<td>'
                pseq_str += pseq_arr[i]
                pseq_str += '</td><td></td><td></td>'

                row_c += 1
                protloc += 6
                if (row_c == 6) {
                    pseq_str += '</tr><tr>'
                    row_c = 0
                }
            }
            pseq_str += '</tr></table>'
            this.pseq = pseq_str
        },
    },
    created: async function () {
        let activeBiomarker = this.$store.getters.getActiveBiomarker
        this.format_protein_sequence(activeBiomarker["UTA_Adapter_protein_sequence"]["protein_sequence"])
    }
}
</script>